import {BehaviorSubject} from "rxjs";
import {StoreConstants} from '../constants/store.constants';

export const DataActions = {
  countries$: (countries$: BehaviorSubject<any>) => ({
    group: StoreConstants.StoreGroups.Data,
    type: StoreConstants.Data.COUNTRIES$,
    countries$
  }),
  userPolicy$: (userPolicy$: any) => ({
    group: StoreConstants.StoreGroups.Data,
    type: StoreConstants.Data.USER_POLICY$,
    userPolicy$
  }),
  privacyPolicy$: (privacyPolicy$: any) => ({
    group: StoreConstants.StoreGroups.Data,
    type: StoreConstants.Data.PRIVACY_POLICY$,
    privacyPolicy$
  }),
  termsOfUse$: (termsOfUse$: any) => ({
    group: StoreConstants.StoreGroups.Data,
    type: StoreConstants.Data.TERMS_OF_USE$,
    termsOfUse$
  }),
  userSettings$: (userSettings$: BehaviorSubject<any>) => ({
    group: StoreConstants.StoreGroups.Data,
    type: StoreConstants.Data.USER_SETTINGS$,
    userSettings$
  }),
  team$: (team$: BehaviorSubject<any>) => ({
    group: StoreConstants.StoreGroups.Data,
    type: StoreConstants.Data.TEAM$,
    team$
  }),
  assets$: (assets$: BehaviorSubject<any>) => ({
    group: StoreConstants.StoreGroups.Data,
    type: StoreConstants.Data.ASSETS$,
    assets$
  }),
  assets: (assets: any) => ({
    group: StoreConstants.StoreGroups.Data,
    type: StoreConstants.Data.ASSETS,
    assets
  }),
  assetFeeds$: (assetFeeds$: BehaviorSubject<any>) => ({
    group: StoreConstants.StoreGroups.Data,
    type: StoreConstants.Data.ASSET_FEEDS$,
    assetFeeds$
  }),
  assetFeeds: (assetFeeds: any) => ({
    group: StoreConstants.StoreGroups.Data,
    type: StoreConstants.Data.ASSET_FEEDS,
    assetFeeds
  })
};
